import $ from 'jquery'

document.addEventListener('DOMContentLoaded', () => {
    const modal = document.querySelector('.modal')
    if (!modal) return
    const modalClose = document.querySelector('.modal__close')
    const modalBackdrop = document.querySelector('.modal__backdrop')

    const closeModal = () => {
        $(modal).hide({
            duration: 100,
        })
    }

    modalClose.addEventListener('click', () => {
        closeModal()
    })

    modalBackdrop.addEventListener('click', () => {
        closeModal()
    })
})
